import { render, staticRenderFns } from "./Arsiv.vue?vue&type=template&id=46234f12&"
import script from "./Arsiv.vue?vue&type=script&lang=js&"
export * from "./Arsiv.vue?vue&type=script&lang=js&"
import style0 from "./Arsiv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports